// extracted by mini-css-extract-plugin
var _1 = "ra-simple-list";
var _2 = "ra-simple-list-item";
var _3 = "ra-simple-list-item-text";
var _4 = "ra-simple-list-small";
export { _1 as "simpleListCls", _2 as "simpleListItemCls", _3 as "simpleListItemTextCls", _4 as "simpleListSmallCls" }
